import { render, staticRenderFns } from "./AdminLatestReport.vue?vue&type=template&id=34dac3dc&"
import script from "./AdminLatestReport.vue?vue&type=script&lang=js&"
export * from "./AdminLatestReport.vue?vue&type=script&lang=js&"
import style0 from "./AdminLatestReport.vue?vue&type=style&index=0&id=34dac3dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports